export default {
  "wrapper": "_wrapper_1w4rlw",
  "options": "_options_1w4rlw",
  "option": "_option_1w4rlw",
  "description": "_description_1w4rlw",
  "description-per-page": "_description-per-page_1w4rlw",
  "summary": "_summary_1w4rlw"
};
